import React from "react";

import { homePath } from "../../../../managerStore";
import logo from "../../../../assets/images/enageed_logo.png";

import styles from "./LoginHeader.module.scss";

export interface LoginHeaderProps {
  school_name: string;
}

export const LoginHeader = (props: LoginHeaderProps) => {
  return (
    <nav className={styles.navHeader}>
      <div className={styles.title}>
        <a href={homePath}>
          <img src={logo} alt="logo" />
        </a>
        <p className={styles.description}>ENAGEEDサービス学校管理画面</p>
      </div>
      <p className={styles.schoolName}>{props.school_name}</p>
    </nav>
  );
};

export default LoginHeader;
